<template>
  <div>
    <p v-for="(text, idx) in texts" :key="idx">
      {{ text }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'TableCellOwner',
  props: {
    payload: Object
  },
  computed: {
    texts () {
      return this.payload.value ? this.payload.value.split('\n') : ''
    }
  }
}
</script>
